// @flow

import React from "react";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import { compose } from "redux";
import { SectionComponent, TooltipDropdown } from "@components";
import type { SpecificDocumentType } from "@modules/shared/reducer/employee-events/types";
import actionCreators from "@modules/shared/actionCreator";
import * as selectors from "@modules/shared/selectors/employee-events";
import type { State } from "@store/reducers";
import { SpecificDocumentsList } from "@modules/shared/components";

type OwnProps = $Exact<{
  employeeId: number,
  clientId: number,
}>;

type PropsFromState = $Exact<{
  documents: Array<SpecificDocumentType>,
}>;

type PropsFromDispatch = $Exact<{
  getDocuments: typeof actionCreators.GetEmployeeDocuments,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export class EmployeeSpecificDocumentsList extends React.Component<Props> {
  componentDidMount() {
    this.props.getDocuments({
      clientId: this.props.clientId,
      employeeId: this.props.employeeId,
    });
  }

  get data() {
    return this.props.documents.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }

  render() {
    return (
      <SectionComponent
        wrapperClassName="flex-column"
        className="gs-container"
        title={
          <TooltipDropdown
            title={this.props.t("ABSENCE_SPECIFIC_DOCUMENTS")}
            description={this.props.t("ABSENCE_SPECIFIC_DOCUMENTS_DESCRIPTION")}
            id="specific-documents-description"
          >
            <h5 className="mr-2">{this.props.t("ABSENCE_SPECIFIC_DOCUMENTS")}</h5>
          </TooltipDropdown>
        }
      >
        <SpecificDocumentsList
          data={this.data}
          employeeId={this.props.employeeId}
          clientId={this.props.clientId}
        />
      </SectionComponent>
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => ({
  documents: selectors.getSpecificDocuments(state),
});

const mapDispatchToProps: PropsFromDispatch = {
  getDocuments: actionCreators.GetEmployeeSpecificDocuments,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  localize(),
)(EmployeeSpecificDocumentsList);
